import React, { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import BarChart from "../../../components/BarChart";
import { sumData } from "../../../utils";
import { useSelector } from "react-redux";
import { postRequest } from "../../../services/api";

const DateWiseShipment = () => {
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [chartData, setChartData] = useState([]);

  const dateWiseFormat = (data) => {
    let arrayResultByDay = sumData(data, "forWeek");
    if(arrayResultByDay.length > 20) {
      arrayResultByDay = sumData(data, "forWeek");
    }
    setChartData(arrayResultByDay);
  };

  useEffect(() => {
      const filterData = data.filter((item) => item.orderStatus === "Shipped");
      dateWiseFormat(data);
  }, [data]);

  const fetchDateWiseShipmentData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      orderStatus: "All",
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getDashCounts_orders",
      payload,
      headers
    );
    setData(response.data.Payload);
  };

  useEffect(() => {
    fetchDateWiseShipmentData();
  }, [startDate, endDate, userSetting]);

  return (
    <div>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography>Shipment</Typography>
      </Stack>

      <BarChart chartName={"Date Wise shipment status"} chartData={chartData} yAxisLabel="Count" xAxisLabel="Week"/>
    </div>
  );
};

export default DateWiseShipment;
